import { data } from '../../svg/Update/data';
import { makeIcon } from '../makeIcon';

export const Update = makeIcon(data, 'update', 'Update');

export default Update;
